import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.scss';

class NewSkillOption extends Component {
  static propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    onClick: PropTypes.func,
  };

  render() {
    return (
      <div
        className="NewSkillField-NewSkillOption"
        onClick={this.props.onClick}
      >
        <div className="NewSkillField-NewSkillOption-icon">
          <i className={this.props.icon} />
        </div>
        <div className="NewSkillField-NewSkillOption-title-container">
          <div className="NewSkillField-NewSkillOption-title-container-title">
            {this.props.title}
          </div>
          <div className="NewSkillField-NewSkillOption-title-container-description">
            {this.props.description}
          </div>
        </div>
        <div className="NewSkillField-NewSkillOption-icon">
          <i className="far fa-plus" />
        </div>
      </div>
    );
  }
}

class NewSkillField extends Component {
  static propTypes = {
    onChange: PropTypes.func,
  };

  handleClick(type) {
    return () => this.props.onChange(type);
  }

  render() {
    return (
      <div className="NewSkillField gecko-card-body">
        <NewSkillOption
          title="Display List"
          description="Give the student a button menu allowing them to go to web pages or trigger another skill"
          icon="far fa-list-alt"
          onClick={this.handleClick('display_list')}
        />
        <NewSkillOption
          title="Suggest Answer"
          description="Give the students some suggestions of what they can ask next"
          icon="far fa-question-circle"
          onClick={this.handleClick('suggest_answer')}
        />
        <NewSkillOption
          title="Data Capture"
          description="Capture data from the student to fill in your GeckoChat contact fields"
          icon="far fa-clipboard-check"
          onClick={this.handleClick('data_capture')}
        />
        <NewSkillOption
          title="Gecko Form"
          description="Capture a response from the student using an existing GeckoForm"
          icon="far fa-clipboard-list-check"
          onClick={this.handleClick('gecko_form')}
        />
        <NewSkillOption
          title="Workflow Action"
          description="Add tags, notes or apply any of the other workflow actions to the contact"
          icon="far fa-cogs"
          onClick={this.handleClick('workflow_action')}
        />
      </div>
    );
  }
}

export default NewSkillField;
